export default __webpack_public_path__ + "static/media/mysql.6e42b2a0.png";